import { CanoRateRow } from "models/axiosModel"

/** Static "Cano Private" speed-boat rates (total boat rate by total pax, 1–40).
 *  Used only as a fallback when the backend did not send `boat_pricing.cano_rates_table`
 *  (e.g. edit mode, where `GET journey-details` has no table and journey-options is not fetched).
 *  Rate: 4000 up to 4 pax, then +100 per extra pax (5 → 4100 … 40 → 7600). */
const CANO_PRIVATE_TOTAL_RATES_BY_PAX: number[] = [
  4000, 4000, 4000, 4000, 4100, 4200, 4300, 4400, 4500, 4600,
  4700, 4800, 4900, 5000, 5100, 5200, 5300, 5400, 5500, 5600,
  5700, 5800, 5900, 6000, 6100, 6200, 6300, 6400, 6500, 6600,
  6700, 6800, 6900, 7000, 7100, 7200, 7300, 7400, 7500, 7600,
]

export const CANO_PRIVATE_FALLBACK_RATES: CanoRateRow[] = CANO_PRIVATE_TOTAL_RATES_BY_PAX.map(
  (totalRate, index) => ({
    pax: index + 1,
    total_rate: totalRate,
    per_person: Math.round((totalRate / (index + 1)) * 100) / 100,
  }),
)

export const isCanoPrivateExcursionName = (name?: string | null): boolean =>
  String(name || "").trim().toLowerCase().includes("cano private")

const hasRows = (table: CanoRateRow[] | undefined | null): table is CanoRateRow[] =>
  Array.isArray(table) && table.length > 0

/** Rate table used to price a speed-boat excursion, in priority order:
 *  1. generic-data `cano_speed_boat_pricing` (global table, always loaded with the page)
 *  2. the excursion's own `boat_pricing.cano_rates_table` from journey-options
 *  3. the static Cano Private table, only for excursions named "Cano Private"
 *  Otherwise empty (price stays 0). */
export const resolveCanoRatesTable = (
  genericTable: CanoRateRow[] | undefined | null,
  journeyOptionsTable: CanoRateRow[] | undefined | null,
  excursionName?: string | null,
): CanoRateRow[] => {
  if (hasRows(genericTable)) return genericTable
  if (hasRows(journeyOptionsTable)) return journeyOptionsTable
  return isCanoPrivateExcursionName(excursionName) ? CANO_PRIVATE_FALLBACK_RATES : []
}
